import { InstitutionalContainer } from './institutional/styles/InstitutionalViewStyles';
import MissionVisionCards from './institutional/components/MissionVisionCards';
import ProcessMap from './institutional/components/ProcessMap';
import Values from './institutional/values/components/Values';

const InstitutionalView = () => {
  return (
    <InstitutionalContainer>
      <MissionVisionCards />
      <Values />
      <ProcessMap />
    </InstitutionalContainer>
  );
};

export default InstitutionalView;
